<template>
  <div>
    <div class="box">
      <admin-form-item label="전송 메시지 설정">
        <lp-radio :val="send_message_setting.send_type"
                  label_name="label"
                  value_name="value"
                  :data="[{label:'SMS',value:0}, {label:'카카오 알림톡', value:1}]"
                  @onSelect="selectSendMessageSetting"></lp-radio>
      </admin-form-item>
    </div>

    <div class="flex-end" style="margin-bottom:12px">
      <button @click="$router.push('sms_message_template/create')"
              style="width:150px"
              class="button is-primary">메시지 템플릿 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 :table_width="700"
                 @selPageLength="selPageLength">

      <div slot="name" slot-scope="props">
        {{ sendPointName(props.item) }}
      </div>

      <div slot="target" slot-scope="props">
        {{ props.item.target==='user'?'회원':props.item.target==='admin'?'관리자':'파트너' }}
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickItem(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger"
                @click.stop.prevent="clickItem(props.item,'delete')">삭제</button>
      </div>

    </admin-table>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import LpRadio from "../../module/common/LpRadio";

  export default {
    name: 'SmsSendPointList',
    components: {LpRadio},
    mixins: [
      ListMixin
    ],
    data() {
      return {
        send_message_setting: {
          send_type: 0
        },
        sendPointArr: []
      }
    },
    created() {
      this.init();
    },
    methods: {
      init () {
        this.initializing('send_message_template', 'sms/send_message_template');
        this.getSendMessageSetting();
        this.getSendPoint();
      },
      getDataFromServer() {
        this.getData();
      },
      getSendPoint() {
        this.$axios.get('admin/sms/send_point').then(res => {
          if (res.status) {
            let result = res.data;
            if (result.length > 0) {
              result.forEach(item => {
                delete item.name;
              })
            }
            this.sendPointArr = result;
          }
        })
      },
      clickItem(item, kind) {
        if (kind === "update") {
          this.$router.push(this.getPath("sms_message_template/create?id=" +item.id));
        } else if (kind === "delete") {
          let value = {
            id: item.id,
            url: 'sms/send_message_template/',
            title: '메시지 템플릿을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
      getSendMessageSetting() {
        this.$axios.get('admin/sms/send_message/setting').then(res=> {
          this.send_message_setting = res.data;
        })
      },
      selectSendMessageSetting(res) {
        this.send_message_setting.send_type = res;
        this.$axios.patch('admin/sms/send_message/setting', this.send_message_setting).then(res=> {
          if(res.status===200) {
            this.toast('전송 메시지 설정이 저장되었습니다.');
          }
        }).catch(error=> {
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        })
      },
      sendPointName(item) {
        if(this.sendPointArr.length>0) {
          return find(this.sendPointArr, 'value', item.name).label
        } else return ''
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
